import { render, staticRenderFns } from "./PopupPanel.vue?vue&type=template&id=1e90b96b&scoped=true&"
import script from "./PopupPanel.vue?vue&type=script&lang=js&"
export * from "./PopupPanel.vue?vue&type=script&lang=js&"
import style0 from "./PopupPanel.vue?vue&type=style&index=0&id=1e90b96b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e90b96b",
  null
  
)

export default component.exports